import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import withRoot from '../modules/withRoot';
import NavBar from '../modules/views/NavBar';
import AppFooter from '../modules/views/AppFooter';
import Section from '../modules/components/Section';
import Button from '../modules/components/Button';
import PageMeta from '../modules/components/PageMeta';

function NotFound() {
  useEffect(() => {
    // CloudFront が 404 を 200 で返す構成のため、少なくとも検索エンジンには
    // インデックス対象外であることを伝える。
    let el = document.head.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', 'robots');
      document.head.appendChild(el);
    }
    el.setAttribute('content', 'noindex, follow');
    return () => {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
  }, []);

  return (
    <React.Fragment>
      <PageMeta title="404 ページが見つかりません" description="お探しのページは見つかりませんでした。" path="/404" />
      <NavBar />
      <Section bg="kinari" py={0} sx={{ textAlign: 'center', pt: { xs: 10, sm: 16 }, pb: { xs: 10, sm: 16 } }}>
        <Typography
          sx={{ fontFamily: "'Noto Serif JP', serif", fontSize: { xs: 56, sm: 88 }, color: 'green', lineHeight: 1.1 }}
        >
          404
        </Typography>
        <Typography variant="h2" component="h1" sx={{ mt: 3, mb: 2 }}>
          ページが見つかりません
        </Typography>
        <Typography sx={{ fontSize: 15, color: 'text.secondary', mb: 5 }}>
          お探しのページは移動または削除された可能性があります。
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button href="/">トップへ戻る</Button>
          <Button
            href="/case"
            sx={{
              bgcolor: 'transparent',
              color: 'green',
              border: (theme) => `1px solid ${theme.palette.green}`,
              '&:hover': { bgcolor: 'kinari' },
            }}
          >
            施工事例を見る
          </Button>
        </Box>
      </Section>
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(NotFound);
